import type { UpdateNotificationSettings200Frequency } from './updateNotificationSettings200Frequency';
import type { UpdateNotificationSettings200TypeSettings } from './updateNotificationSettings200TypeSettings';

export type UpdateNotificationSettings200 = {
  emailEnabled?: boolean;
  frequency?: UpdateNotificationSettings200Frequency;
  inAppEnabled?: boolean;
  pushEnabled?: boolean;
  /** @nullable */
  quietHoursEnd?: string | null;
  /** @nullable */
  quietHoursStart?: string | null;
  smsEnabled?: boolean;
  typeSettings?: UpdateNotificationSettings200TypeSettings;
  userId: string;
};
